<template>
	<div>
		<!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
		<!-- <canvas id="canvas"></canvas> -->
		<!-- <canvas ref="canvas" style="background-color: rgb(255, 255, 255);" height="600px" width="1000px"></canvas> -->
		<p style="opacity: 70%;">
			操作提示：将鼠标移到不同位置查看不同区域功能
		</p>
		<div style="transform: translateX(0px); width: 850px; height: 600px; margin: 0 auto;">
			<img style="position: absolute; left: 0px;border: 1px solid;" ref="image" src="../assets/structure.svg" height="600px" width="850px">
			<div class="part1" @mouseenter="onfocus = 1" @mouseleave="onfocus = 0">
				<p class="comments" v-show="onfocus === 1">
					110kV主网
				</p>
			</div>
			<div class="part2" @mouseenter="onfocus = 2" @mouseleave="onfocus = 0">
				<p class="comments" v-show="onfocus === 2">
					110kV变电站主接线
				</p>
			</div>
			<div class="part3" @mouseenter="onfocus = 3" @mouseleave="onfocus = 0">
				<p class="comments" v-show="onfocus === 3">
					10kV配网主接线
				</p>
			</div>
		</div>
	</div>
</template>
<script>
// import img from "../assets/structure.svg"

export default {
	name: "page1",
	data() {
		return {
			onfocus: 0
		}
	},
	methods: {
		draw() {
			// setInterval(() => {
				let img = this.$refs.image
				let canvas = this.$refs.canvas
				let ctx = canvas.getContext('2d')
				// alert(ctx)
				ctx.fillStyle = '#ff0000'
				// alert(img.complete)
				// setTimeout(() => {
				// 	alert(img.complete, img.width)
				// 	// alert(ctx)	
				// 	// ctx.fillRect(0, 0, 100, 100)
				// }, 1000);
				img.onload = () => {
					// alert(img.complete)
					// if (img.complete) {
						// }
						ctx.drawImage(img, 0, 0, 850, 600);
				}	
			// }, 1);
			
		}
	},
	mounted() {
		this.draw()
	}
}
</script>

<style>
.part1 {
	position: absolute; 
	background-color: rgba(102, 204, 255, 0); 
	width: 850px; 
	height: 110px;
	z-index: 100;
}
.part1:hover {
	position: absolute; 
	background-color: rgba(102, 204, 255, 0.5); 
	width: 850px; 
	height: 110px;
	z-index: 100;
}
.part2 {
	position: absolute; 
	top: 110px; 
	background-color: rgba(102, 204, 255, 0); 
	width: 850px; 
	height: 245px;
	z-index: 100;
}
.part2:hover {
	position: absolute; 
	top: 110px;
	background-color: rgba(102, 204, 255, 0.5); 
	width: 850px; 
	height: 245px;
	z-index: 100;
}
.part3 {
	position: absolute; 
	top: 355px;
	background-color: rgba(102, 204, 255, 0); 
	width: 850px; 
	height: 245px;
	z-index: 100;
}
.part3:hover {
	position: absolute; 
	top: 355px;
	background-color: rgba(102, 204, 255, 0.5); 
	width: 850px; 
	height: 245px;
	z-index: 100;
}
.comments {
	font-size: 13px;
	position: absolute;
	bottom: 5px;
	left: 2px;
	margin: 0 0;
	border-width: 1px;
	border-style: dotted;
	/* display: none; */
}
</style>

